import styled from "styled-components";

export const FooterWrapper = styled.div`
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  margin-top: auto;
  width: 100%;
  border-top: ${({ theme }) =>
    `${theme.borders.width.xs2} solid ${theme.colors.neutral[90]}`};
`;

export const FooterContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 1440px;
  background-color: ${({ theme }) => theme.colors.neutral[100]};
  gap: ${({ theme }) => theme.spacings.xs5};
  padding: ${({ theme }) => `${theme.spacings.xs3} ${theme.spacings.m}`};
`;
